export const PdqFilterTabs = {
    Successful: 0,
    Refunded: 1,
    All: 'all'
};
